// DialogInvoiceAdd Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import currency from '../../../lib/currency.jsx'
import Dialog from '../../../common/layout/dialog/dialog.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Input from '../../../common/form/input/input.jsx'
import Select from '../../../common/form/select/select.jsx'
import FormButton from '../../../common/form/button/button.jsx'
import FormDatePicker from '../../../common/form/form_datepicker/form_datepicker.jsx'
import FormAutoComplete from '../../../common/form/auto_complete/auto_complete.jsx'
import Tab from '../../../common/layout/tab/tab.jsx'
import TabPanel from '../../../common/layout/tab_panel/tab_panel.jsx'
import Dropdown from '../../../common/form/dropdown/dropdown.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import Checkbox from '../../../common/form/checkbox/checkbox.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'
import { Spinner } from '../../../common/common/spinner.jsx'

class DialogInvoiceAdd extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isLoading: false,
      active: false,
      contactId: '',
      projectId: '',
      estimateId: '',
      purchaseOrderId: '',
      referenceNo: '',
      percentage: 100,
      invoiceDate: null,
      dueDate: null,
      contactName: '',
      displayContactName: '',
      showError: false,
      phaseId: '',
      dataDate: null,
      aproveEstimate: false,
      approveDate: new Date(),
      canUseStartTimecards: null,
      isShowCheckbox: false,
      loading: {
        isSubmitting: false,
        isLoadingEstimates: false
      }
    }

    this.data = {
      contacts: [],
      projects: [],
      info: null,
      estimateOptions: [],
      referenceOptions: [],
      phaseOptions: [],
      bHideDrop: false,
      bApprovedEstimate: false
    }

    this.type = 'free-invoicing'
    this.dateMethod = 'entireProject'
    this._bContactSearchPending = null
    this._contactSearchKeyword = ''
    this._references = {
      inputContact: React.createRef(),
      selectProject: React.createRef(),
      selectEstimate: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func,
      contactSearch: PropTypes.func,
      getProjects: PropTypes.func,
      getInvoiceInfo: PropTypes.func,
      invoiceIntroText: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null,
      contactSearch: null,
      getProjects: null,
      getInvoiceInfo: null,
      invoiceIntroText: ''
    }
  }

  show () {
    FabButtonManager.setVisible(false)
    this.setState({ active: true })
  }

  isActive () {
    return this.state.active
  }

  showByEstimate ({
    contactId,
    contactName,
    projectId,
    estimateId,
    bApproved,
    projects,
    referenceNo
  }, onFinish = () => {}) {
    this.type = 'based-on-estimate'
    this.data.projects = projects || []
    this.data.bApprovedEstimate = bApproved || false

    this._getInvoiceInfo(contactId, projectId, null, null, null, () => {
      if (onFinish) onFinish()
      this.setState({
        active: true,
        contactId: contactId,
        displayContactName: contactName,
        projectId: projectId,
        estimateId: estimateId,
        referenceNo: referenceNo || ''
      })
    })
  }

  toggleLoading (key, isLoading) {
    this.setState(prevState => ({ ...prevState, loading: { ...prevState.loading, [key]: isLoading } }))
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({
      active: false,
      contactId: '',
      projectId: '',
      estimateId: '',
      purchaseOrderId: '',
      referenceNo: '',
      percentage: 100,
      invoiceDate: null,
      dueDate: null,
      contactName: '',
      displayContactName: '',
      showError: false,
      phaseId: '',
      dataDate: null,
      approveDate: null,
      aproveEstimate: false,
      canUseStartTimecards: null
    })

    this.data = {
      contacts: [],
      projects: [],
      info: null,
      estimateOptions: [],
      referenceOptions: [],
      phaseOptions: [],
      bHideDrop: false
    }

    this.type = 'free-invoicing'
    this.dateMethod = 'entireProject'
    if (this._references.inputContact.current) {
      this._references.inputContact.current.clearError()
    }

    if (this._references.selectProject.current) {
      this._references.selectProject.current.clearError()
    }
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = (ev) => {
    if (this.state.active && ev.keyCode === 13 && this.state.projectId && this.state.contactId) {
      this._onFormSubmit(ev)
    }
  }

  render () {
    const classHeader = !this.state.showError
      ? 'dialogform-header'
      : 'dialogform-header showerr'
    const bTabFreeDisabled = this._getTabDisable('free')
    const bTabEstimateDisabled = this._getTabDisable('estimate')
    const bTabBudgetDisabled = this._getTabDisable('budget')
    const bTabActualDisabled = this._getTabDisable('actual')
    const { isShowCheckbox, loading: { isSubmitting } } = this.state

    // When we show canUseStartTimecards checkbox, until selected disable save button
    const bSubmitEnabled =
      this.type !== 'based-on-actuals' ||
      !isShowCheckbox ||
      this.state.canUseStartTimecards !== null

    return (
      <Dialog
        active={this.state.active}
        onClose={this.hide.bind(this)}
        type='medium'
      >
        <div className='dialog-form dialog-invoice'>
          <div className={classHeader}>
            {!this.state.showError ? (
              <div className='title'>
                <IntlMessage ident='invoice.form.invoiceTitle' />
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='invoice.form.addErrorInfo' />
              </div>
            )}
            {this._renderPriceInfo()}
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <form className='form' method='post' noValidate action='#'>
              <div className='form-layout'>
                <div className='layoutcol'>
                  <div className='formsection'>
                    <div className='formrow'>
                      <div className='formcol'>
                        <FormAutoComplete
                          label='invoice.form.labelClient'
                          ref={this._references.inputContact}
                          validations={['required']}
                          name='contactId'
                          value={this.state.contactId}
                          displayValue={this.state.displayContactName}
                          options={this.data.contacts}
                          onChange={this._handleSearchContact.bind(this)}
                          onSelect={this._handleContactSelect.bind(
                            this,
                            'contactId'
                          )}
                          hideAdd
                          hasAutoSelect
                        />
                      </div>
                    </div>
                    {!this.data.bHideDrop ? (
                      <div className='formrow'>
                        <div className='formcol'>
                          <Select
                            options={this.data.projects}
                            name='projectId'
                            className='form-dropdown'
                            ref={this._references.selectProject}
                            label='invoice.form.labelProject'
                            value={this.state.projectId}
                            onChange={this._onChangeInput.bind(
                              this,
                              'projectId'
                            )}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className='formrow'>
                        <div className='formcol'>
                          <span className='norecrds'>
                            <IntlMessage ident='invoice.form.noProjectsFoundForClient' />
                          </span>
                        </div>
                      </div>
                    )}
                    <div className='formrow'>
                      <div className='formcol'>
                        <Tab
                          showFullBorder
                          onChange={this._onChangeType.bind(this)}
                        >
                          <TabPanel
                            title='invoice.form.freeInvocing'
                            disable={bTabFreeDisabled}
                            active={this.type === 'free-invoicing'}
                          >
                            {this._renderFreeInvoiceInfo()}
                          </TabPanel>
                          <TabPanel
                            title='invoice.form.basedOnEstimate'
                            disable={bTabEstimateDisabled}
                            active={this.type === 'based-on-estimate'}
                          >
                            {this._renderEstimateInfo()}
                          </TabPanel>
                          <TabPanel
                            title='invoice.form.basedOnBudget'
                            disable={bTabBudgetDisabled}
                            active={this.type === 'based-on-budget'}
                          >
                            {this._renderBudgetInfo()}
                          </TabPanel>
                          <TabPanel
                            title='invoice.form.basedOnActuals'
                            disable={bTabActualDisabled}
                            active={this.type === 'based-on-actuals'}
                          >
                            {this._renderActualsInfo()}
                          </TabPanel>
                        </Tab>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <IconButton
              type='primary'
              size='big'
              icon={!isSubmitting ? 'common-success-tick' : undefined}
              className={bSubmitEnabled ? '' : ' disable'}
              canHover={false}
              title='expense.form.addBudgetExpense'
              onClick={bSubmitEnabled && !isSubmitting ? this._onFormSubmit.bind(this) : null}
            >
              {isSubmitting ? <Spinner size={28} color='#fff' /> : null}
            </IconButton>
          </div>
        </div>
      </Dialog>
    )
  }

  /* Event Handlers */
  _onFormSubmit (ev) {
    ev.preventDefault()

    this.toggleLoading('isSubmitting', true)
    let noErrors = 0

    if (
      (this._references.inputContact.current &&
        !this._references.inputContact.current.validate()) ||
      !this.state.contactId
    ) {
      noErrors++
    }

    if (
      (this._references.selectProject.current &&
        !this._references.selectProject.current.validate()) ||
      !this.state.projectId
    ) {
      noErrors++
    }

    if (
      this.type === 'based-on-estimate' &&
      this._references.selectEstimate.current &&
      !this._references.selectEstimate.current.validate()
    ) {
      noErrors++
    }

    const invoiceDate =
      this.state.invoiceDate &&
      new Date(
        this.state.invoiceDate.getFullYear(),
        this.state.invoiceDate.getMonth(),
        this.state.invoiceDate.getDate()
      )
    const dueDate =
      this.state.dueDate &&
      new Date(
        this.state.dueDate.getFullYear(),
        this.state.dueDate.getMonth(),
        this.state.dueDate.getDate()
      )
    if (dueDate) {
      dueDate.setHours(23, 59, 59, 0)
    }

    if (noErrors === 0) {
      const invoiceObj = {
        contactId: this.state.contactId,
        projectId: this.state.projectId,
        estimateId: this.state.estimateId,
        purchaseOrderId: this.state.purchaseOrderId,
        type: this.type,
        referenceNo: this.state.referenceNo ? this.state.referenceNo : '',
        percentage: this.state.percentage,
        invoiceDate: invoiceDate,
        dueDate: dueDate,
        budget: {
          phases: [
            {
              title: '',
              total: 0,
              percentage: 0,
              spentAmount: 0
            }
          ],
          totalSpent: 0,
          total: 0
        },
        dateMethod: this.dateMethod,
        approveDate: this.state.approveDate,
        approveEstimate: this.state.aproveEstimate,
        canUseStartTimecards: this.state.canUseStartTimecards,
        introText: this.props.invoiceIntroText
      }

      if (this.props.onSubmit) {
        this.props.onSubmit(invoiceObj, this.state.phaseId, () => {
          this.toggleLoading('isSubmitting', false)
        })
      }
    } else {
      this.setState({ showError: true, loading: { isSubmitting: false } })
    }
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()
  }

  _onChangeDate (name, value) {
    this.dateMethod = ''
    value = value || (name === 'invoiceDate' ? null : new Date())
    this.setState({ [name]: value }, () => {
      this._refreshInvoiceInfoForDate()
    })
  }

  _refreshInvoiceInfoForDate () {
    this._getInvoiceInfo(
      this.state.contactId,
      this.state.projectId,
      this.state.invoiceDate,
      this.state.dueDate,
      this.state.phaseId
    )
  }

  _onChangePurchaseOrder (name, value) {
    this.setState({ referenceNo: value })
  }

  _onChangeType (index) {
    let type = ''

    if (index === 0) {
      type = 'free-invoicing'
    } else if (index === 1) {
      type = 'based-on-estimate'
    } else if (index === 2) {
      type = 'based-on-budget'
    } else if (index === 3) {
      type = 'based-on-actuals'
    }

    this.type = type
    this._getInvoiceInfo(
      this.state.contactId,
      this.state.projectId,
      this.state.invoiceDate,
      this.state.dueDate,
      this.state.phaseId
    )
  }

  _onChangeMethod (name) {
    if (name) {
      this.dateMethod = name
      let fromDate = null
      let toDate = null
      let isShowCheckbox = false
      let canUseStartTimecards = null

      if (name === 'entireProject') {
        if (this.data.info && this.data.info.project) {
          const project = this.data.info.project
          fromDate = new Date(project.createdOn)
          toDate = project.endDate ? new Date(project.endDate) : new Date()
        }
      } else if (name === 'lastInvoice') {
        if (this.data.info && this.data.info.lastInvoice) {
          const lastInvoice = this.data.info.lastInvoice
          fromDate = new Date(lastInvoice.invoiceDate)
          toDate = new Date(lastInvoice.dueDate)
        }

        isShowCheckbox = true
        canUseStartTimecards = this.state.canUseStartTimecards
      } else if (name === 'lastMonth') {
        const date = DateUtil.getUTCCurrentDate()
        fromDate = new Date(date.getFullYear(), date.getMonth() - 1, 1)
        toDate = new Date(date.getFullYear(), date.getMonth(), 0)

        isShowCheckbox = true
        canUseStartTimecards = this.state.canUseStartTimecards
      } else if (name === 'currentMonth') {
        const date = DateUtil.getUTCCurrentDate()
        fromDate = new Date(date.getFullYear(), date.getMonth(), 1)
        toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0)

        isShowCheckbox = true
        canUseStartTimecards = this.state.canUseStartTimecards
      }

      this.setState(
        {
          invoiceDate: fromDate,
          dueDate: toDate,
          dataDate: new Date(),
          isShowCheckbox,
          canUseStartTimecards
        },
        () => {
          this._getInvoiceInfo(
            this.state.contactId,
            this.state.projectId,
            fromDate,
            toDate,
            this.state.phaseId
          )
        }
      )
    }
  }

  _onChangeInput (name, value) {
    if (name === 'projectId') {
      this._getInvoiceInfo(
        this.state.contactId,
        value,
        this.state.invoiceDate,
        this.state.dueDate,
        this.state.phaseId
      )
    }

    if (name === 'phaseId') {
      this._getInvoiceInfo(
        this.state.contactId,
        this.state.projectId,
        this.state.invoiceDate,
        this.state.dueDate,
        value
      )
    }

    if (name === 'estimateId' && this.data.estimateOptions.length > 0) {
      let referenceNo = this.state.referenceNo
      const estimate = _.find(this.data.estimateOptions, (estObj) => {
        this.data.bApprovedEstimate =
          estObj.status === 'Approved'
        return estObj.value === value
      })

      if (estimate && estimate.referenceNumber) {
        referenceNo = estimate.referenceNumber
      }

      this.setState({ referenceNo: referenceNo })
    }

    this.setState({ [name]: value })
  }

  _onCheckEstimate () {
    this.setState({ aproveEstimate: !this.state.aproveEstimate })
  }

  _getInvoiceInfo (
    contactId,
    projectId,
    fromExpenseDate,
    toExpenseDate,
    phaseId,
    callback
  ) {
    if (this.props.getInvoiceInfo) {
      if (fromExpenseDate) {
        fromExpenseDate = new Date(
          fromExpenseDate.getFullYear(),
          fromExpenseDate.getMonth(),
          fromExpenseDate.getDate()
        )
      }
      if (toExpenseDate) {
        toExpenseDate = new Date(
          toExpenseDate.getFullYear(),
          toExpenseDate.getMonth(),
          toExpenseDate.getDate()
        )
        toExpenseDate.setHours(23, 59, 59, 0)
      }

      let bCanUseStartTimecards = false
      if (this.type === 'based-on-actuals') {
        bCanUseStartTimecards = this.state.canUseStartTimecards || false
      }

      const params = {
        query: {
          $client: {
            filter: {
              contactId: contactId || this.state.contactId,
              projectId: projectId || this.state.projectId,
              phaseId: phaseId,
              fromExpenseDate:
                (this.dateMethod === 'entireProject' &&
                  this.type === 'based-on-actuals') ||
                bCanUseStartTimecards
                  ? null
                  : fromExpenseDate,
              toExpenseDate:
                this.dateMethod === 'entireProject' &&
                this.type === 'based-on-actuals'
                  ? null
                  : toExpenseDate,
              type: this.type,
              bReturnItems: false
            }
          }
        }
      }

      this.toggleLoading('isLoadingEstimates', true)

      this.props.getInvoiceInfo(params, (result) => {
        this.toggleLoading('isLoadingEstimates', false)
        if (result) {
          this._processProjectInfoRepsonse(result)
        }

        if (callback) {
          callback()
        }
      })
    }
  }

  _processProjectInfoRepsonse (result) {
    this.data.info = result
    this.data.estimateOptions = result.estimates.map((estimate) => ({
      label: estimate.title,
      value: estimate.id,
      referenceNumber: estimate.referenceNumber,
      status: estimate.status
    }))
    this.data.referenceOptions = []
    if (result.references && result.references.length > 0) {
      this.data.referenceOptions = result.references.map((reference) => {
        const label = `${reference.invoiceNo} ${currency.format(
          reference.total
        )}`
        return {
          label: label,
          value: reference.referenceNumber
        }
      })
    }
    this.data.phaseOptions = result.budgetInfo.phaseOptions

    const stateObj = {
      dataDate: new Date()
    }

    if (this.dateMethod === 'entireProject') {
      stateObj.dueDate = this.data.info.project.endDate
        ? new Date(this.data.info.project.endDate)
        : null
    }

    this.setState(stateObj)
  }

  _handleSearchContact (keyword) {
    if (keyword && this._references.inputContact.current) {
      this._references.inputContact.current.clearError()
    }

    this.setState({ displayContactName: keyword })
    this._processContactSearch(keyword)
  }

  _processContactSearch (keyword) {
    if (keyword.length < 1) return

    if (!this._bContactSearchPending) {
      this._bContactSearchPending = true
      if (this.props.contactSearch) {
        this.props.contactSearch(
          keyword,
          this._onSearchRecieved.bind(this, keyword)
        )
      }
    } else {
      this._contactSearchKeyword = keyword
    }
  }

  _onSearchRecieved (keyword, result) {
    this._bContactSearchPending = false
    this.data.contacts = result.filter(contact => contact.bArchived === false)
    const stateObj = {}
    if (result && result.length > 0) {
      stateObj.contactId = ''
      stateObj.contactName = keyword
    }

    this.setState(stateObj)

    if (this._contactSearchKeyword) {
      const keyword = this._contactSearchKeyword
      this._contactSearchKeyword = ''
      this._processContactSearch(keyword)
    }
  }

  _handleContactSelect (name, obj) {
    if (obj) {
      this.setState({ [name]: obj.value, displayContactName: obj.label })

      if (this.props.getProjects) {
        this.props.getProjects(obj.value, (obj) => {
          this.data.projects = obj

          this.data.bHideDrop = false
          if (this.data.projects.length === 0) {
            this.data.bHideDrop = true
          }

          this.setState({ dataDate: new Date() })
        })
      }
    } else {
      this.data.projects = []
      this.data.bHideDrop = false

      this.setState({ [name]: '' })
    }
  }

  _getTabDisable (type) {
    let bDisable = true
    if (type === 'free' && this.state.projectId) {
      bDisable = false
    } else if (
      type === 'estimate' &&
      this.data.info &&
      this.data.info.estimates.length > 0
    ) {
      bDisable = false
    } else if (
      type === 'budget' &&
      this.data.info &&
      (this.data.info.budgetInfo.expenseTotal > 0 ||
        this.data.info.budgetInfo.timeTotal)
    ) {
      bDisable = false
    } else if (
      type === 'actual' &&
      this.data.info &&
      (this.data.info.actualsInfo.timeCount > 0 ||
        this.data.info.actualsInfo.timeTotal)
    ) {
      bDisable = false
    }

    return bDisable
  }

  /* Private functions */
  _renderPriceInfo () {
    if (this.type === 'based-on-estimate') {
      const estimateObj = _.find(this.data.info?.estimates ?? [], (estimate) => {
        return estimate.id === this.state.estimateId ? estimate : null
      })
      const total = estimateObj ? estimateObj.total : 0
      let estimateTotal = total || '0,00'

      if (this.state.percentage <= 100) {
        estimateTotal = (this.state.percentage * total) / 100
      }

      return (
        <div className='priceinfolist'>
          <div className='priceinfo'>
            <div className='label'>
              <IntlMessage ident='invoice.form.invoiceTotal' />
            </div>
            <div className='content'>
              <PriceText value={estimateTotal} />
            </div>
          </div>
        </div>
      )
    } else if (this.type === 'based-on-budget') {
      let timeTotal = this.data.info.budgetInfo.timeTotal
      if (this.state.percentage <= 100) {
        timeTotal =
          (this.state.percentage * this.data.info.budgetInfo.timeTotal) / 100
      }
      let expenseTotal = this.data.info.budgetInfo.expenseTotal
      if (this.state.percentage <= 100) {
        expenseTotal =
          (this.state.percentage * this.data.info.budgetInfo.expenseTotal) /
          100
      }
      return (
        <div className='priceinfolist'>
          <div className='priceinfo'>
            <div className='label'>
              {this.data.info.budgetInfo.timeCount}
              <IntlMessage ident='invoice.form.budgetInfoTime' />
            </div>
            <div className='content'>
              <PriceText value={timeTotal} />
            </div>
          </div>
          <div className='priceinfo'>
            <div className='label'>
              {this.data.info.budgetInfo.expenseCount}
              <IntlMessage ident='invoice.form.budgetInfoExpenses' />
            </div>
            <div className='content'>
              <PriceText value={expenseTotal} />
            </div>
          </div>
        </div>
      )
    } else if (this.type === 'based-on-actuals') {
      return (
        <div className='priceinfolist'>
          <div className='priceinfo'>
            <div className='label'>
              {this.data.info.actualsInfo.timeCount}
              <IntlMessage ident='invoice.form.budgetInfoTime' />
            </div>
            <div className='content'>
              <PriceText value={this.data.info.actualsInfo.timeTotal} />
            </div>
          </div>
          <div className='priceinfo'>
            <div className='label'>
              {this.data.info.actualsInfo.expenseCount}
              <IntlMessage ident='invoice.form.budgetInfoExpenses' />
            </div>
            <div className='content'>
              <PriceText value={this.data.info.actualsInfo.expenseTotal} />
            </div>
          </div>
        </div>
      )
    }

    return null
  }

  _renderFreeInvoiceInfo () {
    return (
      <div className='freeinvoicerow'>
        <div className='formrow'>
          <div className='formcol'>
            <Input
              type='text'
              name='referenceNo'
              label='invoice.form.labelPoNumber'
              size={10}
              maxLength={100}
              styleDotted
              validations={['required']}
              value={this.state.referenceNo}
              onChange={this._onChangeInput.bind(this, 'referenceNo')}
            />
          </div>
        </div>
        {this.state.projectId && this.data.referenceOptions.length > 0 && (
          <div className='formrow reference'>
            <div className='formcol'>
              <Dropdown
                source={this.data.referenceOptions}
                name='purchaseOrderNo'
                label='invoice.form.choosePurchaseOrderNo'
                multilingual={false}
                className='gridsort-dropdown purchaseOrder-dropdown'
                onChange={this._onChangePurchaseOrder.bind(
                  this,
                  'purchaseOrderNo'
                )}
              />
            </div>
          </div>
        )}
      </div>
    )
  }

  _renderEstimateInfo () {
    const { loading: { isLoadingEstimates } } = this.state

    return (
      <div className='estimaterow'>
        <div className='formrow'>
          <div className='formcol'>
            <Select
              options={this.data.estimateOptions}
              name='estimateId'
              label='invoice.form.labelEstimates'
              ref={this._references.selectEstimate}
              className='form-dropdown'
              value={this.state.estimateId}
              onChange={this._onChangeInput.bind(this, 'estimateId')}
              isLoading={isLoadingEstimates}
            />
          </div>
        </div>
        <div className='formrow'>
          <div className='formcol'>
            <div className='title'>
              <IntlMessage ident='invoice.form.titleEstimateText' />
            </div>
          </div>
        </div>
        <div className='formrow estimate'>
          <div className='formcol2 formcol2_alt'>
            <Input
              type='text'
              name='percentage'
              className='invoicesuffix-input'
              suffix='invoice.form.suffixPercentage'
              size={10}
              validations={['required']}
              value={this.state.percentage}
              onChange={this._onChangeInput.bind(this, 'percentage')}
            />
          </div>
          <div className='formcol2'>
            <Input
              type='text'
              name='referenceNo'
              label='invoice.form.labelPoNumber'
              size={10}
              maxLength={100}
              styleDotted
              validations={['required']}
              value={this.state.referenceNo}
              onChange={this._onChangeInput.bind(this, 'referenceNo')}
            />
          </div>
        </div>
        {this.state.aproveEstimate && (
          <div className='formrow'>
            <div className='formcol'>
              <FormDatePicker
                label='invoice.form.estimateApproveDate'
                placeholder='invoice.form.estimateApproveDate'
                value={this.state.approveDate}
                name='approveDate'
                onChange={this._onChangeInput.bind(this, 'approveDate')}
              />
            </div>
          </div>
        )}

        {!this.data.bApprovedEstimate && (
          <div className='formrow approve'>
            <div className='formcol2'>
              <Checkbox
                label='invoice.form.estimateAproveText'
                checked={this.state.aproveEstimate}
                icon='login'
                onChange={this._onCheckEstimate.bind(this)}
              />
            </div>
          </div>
        )}
      </div>
    )
  }

  _renderBudgetInfo () {
    return (
      <div className='budgetrow'>
        {this.data.phaseOptions && this.data.phaseOptions.length && (
          <div className='formrow'>
            <div className='formcol'>
              <Select
                options={this.data.phaseOptions}
                name='phaseId'
                label='invoice.form.phaseLabel'
                className='form-dropdown'
                onChange={this._onChangeInput.bind(this, 'phaseId')}
                value={this.state.phaseId}
              />
            </div>
          </div>
        )}
        <div className='formrow'>
          <div className='formcol'>
            <div className='title'>
              <IntlMessage ident='invoice.form.titleBudgetText' />
            </div>
          </div>
        </div>
        <div className='formrow'>
          <div className='formcol2 formcol2_alt'>
            <Input
              type='text'
              name='percentage'
              label='invoice.form.percentage'
              value={this.state.percentage}
              className='invoicesuffix-input'
              suffix='invoice.form.suffixPercentage'
              size={10}
              validations={['required']}
              onChange={this._onChangeInput.bind(this, 'percentage')}
            />
          </div>
          <div className='formcol2'>
            <Input
              type='text'
              name='referenceNo'
              label='invoice.form.labelPoNumber'
              size={10}
              maxLength={100}
              styleDotted
              validations={['required']}
              value={this.state.referenceNo}
              onChange={this._onChangeInput.bind(this, 'referenceNo')}
            />
          </div>
        </div>
        {this.state.projectId && this.data.referenceOptions.length > 0 && (
          <div className='formrow reference'>
            <div className='formcol'>
              <Dropdown
                source={this.data.referenceOptions}
                name='purchaseOrderNo'
                label='invoice.form.choosePurchaseOrderNo'
                multilingual={false}
                className='gridsort-dropdown purchaseOrder-dropdown'
                onChange={this._onChangePurchaseOrder.bind(
                  this,
                  'purchaseOrderNo'
                )}
              />
            </div>
          </div>
        )}
      </div>
    )
  }

  _renderActualsInfo () {
    const { isShowCheckbox } = this.state

    return (
      <div className='actualsrow'>
        <div className='formrow'>
          <div className='formcol'>
            <div className='title'>
              <IntlMessage ident='invoice.form.titleDateText' />
            </div>
          </div>
        </div>
        <div className='formrow'>
          <div className='formcol2 formcol2_date'>
            <FormDatePicker
              label='invoice.form.invoiceStartDate'
              placeholder='invoice.form.invoiceStartDate'
              value={this.state.invoiceDate}
              name='invoiceDate'
              onChange={this._onChangeDate.bind(this, 'invoiceDate')}
            />
          </div>
          <div className='formcol2 formcol2_date'>
            <FormDatePicker
              label='invoice.form.invoiceEndDate'
              placeholder='invoice.form.invoiceEndDate'
              value={this.state.dueDate}
              name='dueDate'
              onChange={this._onChangeDate.bind(this, 'dueDate')}
            />
          </div>
        </div>
        <div className='formrow action'>
          <div className='formcol'>
            <FormButton
              title='invoice.form.labelEntireProject'
              className={this.dateMethod === 'entireProject' ? 'wizard' : ''}
              type='button'
              onClick={this._onChangeMethod.bind(this, 'entireProject')}
            />
            <FormButton
              title='invoice.form.labelSinceLastInvoice'
              className={this.dateMethod === 'lastInvoice' ? 'wizard' : ''}
              type='button'
              onClick={this._onChangeMethod.bind(this, 'lastInvoice')}
            />
            <FormButton
              title='invoice.form.labelLastMonth'
              className={this.dateMethod === 'lastMonth' ? 'wizard' : ''}
              type='button'
              onClick={this._onChangeMethod.bind(this, 'lastMonth')}
            />
            <FormButton
              title='invoice.form.labelCurrentMonth'
              className={this.dateMethod === 'currentMonth' ? 'wizard' : ''}
              type='button'
              onClick={this._onChangeMethod.bind(this, 'currentMonth')}
            />
          </div>
        </div>
        <div className='formrow'>
          <div className='formcol'>
            <Input
              type='text'
              name='referenceNo'
              label='invoice.form.labelPoNumber'
              size={10}
              maxLength={100}
              styleDotted
              validations={['required']}
              value={this.state.referenceNo}
              onChange={this._onChangeInput.bind(this, 'referenceNo')}
            />
          </div>
        </div>
        {this.state.projectId && this.data.referenceOptions.length > 0 && (
          <div className='formrow reference'>
            <div className='formcol'>
              <Dropdown
                source={this.data.referenceOptions}
                name='purchaseOrderNo'
                label='invoice.form.choosePurchaseOrderNo'
                className='gridsort-dropdown purchaseOrder-dropdown'
                multilingual={false}
                onChange={this._onChangePurchaseOrder.bind(
                  this,
                  'purchaseOrderNo'
                )}
              />
            </div>
          </div>
        )}
        {isShowCheckbox && (
          <div className='formrow'>
            <div className='formrow timecardconfirmation'>
              <IntlMessage ident='invoice.form.timecardConfirmation' />
            </div>
            <div className='formrow confirmation'>
              <div className='form-checkyes'>
                <div
                  className='checkbox yes'
                  onClick={this._onChangeCheckbox.bind(this, true)}
                >
                  <div
                    className={`checkbox-inner${
                      this.state.canUseStartTimecards ? ' checked' : ''
                    }`}
                  />
                </div>
                <span className='confirmationtitle'>
                  <IntlMessage ident='invoice.form.timecardConfirmationYes' />
                </span>
              </div>
              <div className='form-checkno'>
                <div
                  className='checkbox no'
                  onClick={this._onChangeCheckbox.bind(this, false)}
                >
                  <div
                    className={`checkbox-inner${
                      this.state.canUseStartTimecards === false
                        ? ' checked'
                        : ''
                    }`}
                  />
                </div>
                <span className='confirmationtitle'>
                  <IntlMessage ident='invoice.form.timecardConfirmationNo' />
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  _onChangeCheckbox (bChecked) {
    this.setState({ canUseStartTimecards: bChecked }, () => {
      this._refreshInvoiceInfoForDate()
    })
  }
}

export default DialogInvoiceAdd
